"use strict";

var _regeneratorRuntime = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = void 0;

var Logger_1 = require("./Logger");

var EnhancedEventEmitter_1 = require("./EnhancedEventEmitter");

var errors_1 = require("./errors");

var logger = new Logger_1.Logger('Consumer');

var Consumer = /*#__PURE__*/function (_EnhancedEventEmitter) {
  _inherits(Consumer, _EnhancedEventEmitter);

  var _super = _createSuper(Consumer);

  function Consumer(_ref) {
    var _this;

    var id = _ref.id,
        localId = _ref.localId,
        producerId = _ref.producerId,
        rtpReceiver = _ref.rtpReceiver,
        track = _ref.track,
        rtpParameters = _ref.rtpParameters,
        appData = _ref.appData;

    _classCallCheck(this, Consumer);

    _this = _super.call(this); // Closed flag.

    _this._closed = false; // Observer instance.

    _this._observer = new EnhancedEventEmitter_1.EnhancedEventEmitter();
    logger.debug('constructor()');
    _this._id = id;
    _this._localId = localId;
    _this._producerId = producerId;
    _this._rtpReceiver = rtpReceiver;
    _this._track = track;
    _this._rtpParameters = rtpParameters;
    _this._paused = !track.enabled;
    _this._appData = appData || {};
    _this.onTrackEnded = _this.onTrackEnded.bind(_assertThisInitialized(_this));

    _this.handleTrack();

    return _this;
  }
  /**
   * Consumer id.
   */


  _createClass(Consumer, [{
    key: "close",

    /**
     * Closes the Consumer.
     */
    value: function close() {
      if (this._closed) {
        return;
      }

      logger.debug('close()');
      this._closed = true;
      this.destroyTrack();
      this.emit('@close'); // Emit observer event.

      this._observer.safeEmit('close');
    }
    /**
     * Transport was closed.
     */

  }, {
    key: "transportClosed",
    value: function transportClosed() {
      if (this._closed) {
        return;
      }

      logger.debug('transportClosed()');
      this._closed = true;
      this.destroyTrack();
      this.safeEmit('transportclose'); // Emit observer event.

      this._observer.safeEmit('close');
    }
    /**
     * Get associated RTCRtpReceiver stats.
     */

  }, {
    key: "getStats",
    value: function () {
      var _getStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._closed) {
                  _context.next = 2;
                  break;
                }

                throw new errors_1.InvalidStateError('closed');

              case 2:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  _this2.safeEmit('@getstats', resolve, reject);
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getStats() {
        return _getStats.apply(this, arguments);
      }

      return getStats;
    }()
    /**
     * Pauses receiving media.
     */

  }, {
    key: "pause",
    value: function pause() {
      logger.debug('pause()');

      if (this._closed) {
        logger.error('pause() | Consumer closed');
        return;
      }

      if (this._paused) {
        logger.debug('pause() | Consumer is already paused');
        return;
      }

      this._paused = true;
      this._track.enabled = false;
      this.emit('@pause'); // Emit observer event.

      this._observer.safeEmit('pause');
    }
    /**
     * Resumes receiving media.
     */

  }, {
    key: "resume",
    value: function resume() {
      logger.debug('resume()');

      if (this._closed) {
        logger.error('resume() | Consumer closed');
        return;
      }

      if (!this._paused) {
        logger.debug('resume() | Consumer is already resumed');
        return;
      }

      this._paused = false;
      this._track.enabled = true;
      this.emit('@resume'); // Emit observer event.

      this._observer.safeEmit('resume');
    }
  }, {
    key: "onTrackEnded",
    value: function onTrackEnded() {
      logger.debug('track "ended" event');
      this.safeEmit('trackended'); // Emit observer event.

      this._observer.safeEmit('trackended');
    }
  }, {
    key: "handleTrack",
    value: function handleTrack() {
      this._track.addEventListener('ended', this.onTrackEnded);
    }
  }, {
    key: "destroyTrack",
    value: function destroyTrack() {
      try {
        this._track.removeEventListener('ended', this.onTrackEnded);

        this._track.stop();
      } catch (error) {}
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
    /**
     * Local id.
     */

  }, {
    key: "localId",
    get: function get() {
      return this._localId;
    }
    /**
     * Associated Producer id.
     */

  }, {
    key: "producerId",
    get: function get() {
      return this._producerId;
    }
    /**
     * Whether the Consumer is closed.
     */

  }, {
    key: "closed",
    get: function get() {
      return this._closed;
    }
    /**
     * Media kind.
     */

  }, {
    key: "kind",
    get: function get() {
      return this._track.kind;
    }
    /**
     * Associated RTCRtpReceiver.
     */

  }, {
    key: "rtpReceiver",
    get: function get() {
      return this._rtpReceiver;
    }
    /**
     * The associated track.
     */

  }, {
    key: "track",
    get: function get() {
      return this._track;
    }
    /**
     * RTP parameters.
     */

  }, {
    key: "rtpParameters",
    get: function get() {
      return this._rtpParameters;
    }
    /**
     * Whether the Consumer is paused.
     */

  }, {
    key: "paused",
    get: function get() {
      return this._paused;
    }
    /**
     * App custom data.
     */

  }, {
    key: "appData",
    get: function get() {
      return this._appData;
    }
    /**
     * Invalid setter.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ,
    set: function set(appData) {
      throw new Error('cannot override appData object');
    }
  }, {
    key: "observer",
    get: function get() {
      return this._observer;
    }
  }]);

  return Consumer;
}(EnhancedEventEmitter_1.EnhancedEventEmitter);

exports.Consumer = Consumer;